import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { Typography } from "@mui/material";
import theme from "../../theme";
import { StyledErrorMessage } from "../style/modalStyle";
interface RadioProps {
  label: string;
  names: string;
  trueLabel: string;
  falseLabel: string;
  formik: any;
  disabled?:boolean;
  isGap?:boolean;
}
export default function CommonRadioButton(props: RadioProps) {
  const { label, names, formik, trueLabel, falseLabel, disabled, isGap } = props;

  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const value = event.target.value === "yes" ? 1 : 0; // Store ID
  //   formik.setFieldValue(names, value);
  // };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value;
    if (names === "company_type") {
      value = event.target.value === "yes" ? 1 : 2; // 1 for LLC, 2 for C-Corp
    } else {
      value = event.target.value === "yes"; // true for Yes, false for No
    }
    formik.setFieldValue(names, value);
  };

  return (
    <>
      <FormControl
        sx={{ width: "100%" }}
        error={formik.touched[names] && Boolean(formik.errors[names])}
      >
        <Typography
          variant="h4"
          sx={{
            // whiteSpace: "nowrap",
            fontSize: "18px",
            fontWeight: 600,
            color: "#060110",
          }}
        >
          {label && label.includes('*') ? (
          <>
            {label.replace('*', '')}
            <span style={{ color: '#ff0000' }}>*</span>
          </>
        ) : (
          label
        )}
         
        </Typography>
        <RadioGroup
          row
          aria-labelledby="demo-controlled-radio-buttons-group"
          name={names}
        
          value={
            names === "company_type"
              ? formik.values[names] != null
                ? formik.values[names] === 1
                  ? "yes"
                  : "no"
                : ""
              : formik.values[names] != null
              ? formik.values[names] === true
                ? "yes"
                : "no"
              : ""
          }
          onChange={handleChange}
            sx={{
              marginY: isGap ? 0 : 2,
              ...(isGap
                ? { 
                    justifyContent: { xs: "flex-start", sm: "space-between" }
                  }
                : { gap: "60px" })
            }}
        >
          <FormControlLabel
            value="yes"
            control={
              <Radio
              disabled={disabled}
                sx={{
                  "& .MuiSvgIcon-root": {
                    color: "#2977CC",
                  },
                }}
              />
            }
            sx={{
              gap: "10px",
              "& .MuiFormControlLabel-label": {
                fontSize: "16px",
                fontWeight: 600,
                color: "#2C3034",
                gap: "60px",
              },
            }}
            label={trueLabel}
          />
          <FormControlLabel
            // defaultChecked
            value="no"
            control={
              <Radio
              disabled={disabled}
                sx={{
                  "& .MuiSvgIcon-root": {
                    color: "#2977CC",
                  },
                }}
              />
            }
            sx={{
              gap: "10px",
              "& .MuiFormControlLabel-label": {
                fontSize: "16px",
                fontWeight: 600,
                color: "#2C3034",
              },
            }}
            label={falseLabel}
          />
        </RadioGroup>
      </FormControl>
      <StyledErrorMessage>
        
           {formik?.errors[names ?? ""] &&
          (formik?.touched[names ?? ""] || formik?.submitCount > 0) &&
          formik?.errors[names ?? ""]}
      </StyledErrorMessage>
    </>
  );
}
